module.exports = __webpack_public_path__ + "static/media/Unarchive.4e5964fd.svg";